import { Translation } from "primeng/api";

export const primeNgTranslation: Translation = {
  accept: 'Accept',
  reject: 'Cancel',
  monthNames: [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ],
  dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
  monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
  emptyFilterMessage: 'No se encontraron resultados',
  emptyMessage: 'No se encontraron resultados',
  passwordPrompt: 'Ingrese la contraseña.',
  weak: 'Débil',
  strong: 'Fuerte',
  medium: 'Media',
  clear: 'Limpiar',
  apply: 'Aplicar',
  matchAll: 'Combinar todos',
  matchAny: 'Combinar cualquiera',
  addRule: 'Agregar regla',
  removeRule: 'Quitar regla',
  dateIs: 'La fecha es',
  dateIsNot: 'La fecha no es',
  dateBefore: 'La fecha está antes de',
  dateAfter: 'La fecha está después de',
  dateFormat: 'dd/mm/yy',
  selectionMessage: '{0} ítems seleccionados',
  today: 'Hoy',
};
